import { useEffect } from "react";
import { useRouteMatch } from "react-router";
import type { Attributes, LMTScreen } from "../../../types/Analytics";
import { logScreenView } from "../../../utils/analytics.util";
import {
    useMembersUrlFilter,
    useRequestsUrlFilter,
    useTasksUrlFilter,
} from "../../../utils/customHook.util";

type TrackedScreenProps = {
    screen: LMTScreen;
    attributes: Pick<Attributes, "lmt_a_agent"> & Partial<Attributes>;
    children: React.JSX.Element;
};

function TrackedScreen(props: TrackedScreenProps) {
    const { attributes, children, screen } = props;

    const memberId = useRouteMatch<{
        memberId: string;
    }>("/member/:memberId")?.params.memberId;

    const membersFilter = useMembersUrlFilter();

    const requestId = useRouteMatch<{
        requestId: string;
    }>("/request/:requestId")?.params.requestId;

    const requestsFilter = useRequestsUrlFilter();

    const tasksFilter = useTasksUrlFilter();

    const listQuery =
        membersFilter || requestsFilter || tasksFilter
            ? window.location.search
            : undefined;

    useEffect(() => {
        if (screen && attributes) {
            logScreenView({
                name: screen,
                partialAttributes: {
                    ...attributes,
                    ...(memberId ? { a_member: memberId } : {}),
                    ...(requestId ? { a_request: requestId } : {}),
                    ...(membersFilter ? { a_members_filter: membersFilter } : {}),
                    ...(requestsFilter ? { a_requests_filter: requestsFilter } : {}),
                    ...(tasksFilter ? { a_tasks_filter: tasksFilter } : {}),
                    ...(listQuery ? { a_list_query: listQuery } : {}),
                },
            });
        }
    }, [screen, attributes]);

    return children;
}

export default TrackedScreen;
